import React, { useState } from "react";

import { Layout } from "antd";

import SideNav, { getSideNavCollapsed } from "../Common/UIComponents/SideNav";

import { permissions } from "../../utils/Permissions";
import { canViewInvoice, canViewUsageMetrics } from "./UsageMetrics/utils";

import helpIconInactive from "../../assets/images/helpIconInactive.svg";
import helpIconActive from "../../assets/images/logo/helpIconPrimary.svg";
import myProfileIconActive from "../../assets/images/logo/myProfileIconPrimary.svg";
import myProfileIconInactive from "../../assets/images/myProfileIconInactive.svg";
import usageMetricsIconActive from "../../assets/images/subscriptions/currency-fill.svg";
import usageMetricsIconInactive from "../../assets/images/subscriptions/currency-line.svg";
import invoiceIconActive from "../../assets/images/subscriptions/receipt-fill.svg";
import invoiceIconInactive from "../../assets/images/subscriptions/receipt-line.svg";
import teamMemberIconInactive from "../../assets/images/teamMemberIconInactive.svg";
import teamMemberIconActive from "../../assets/images/teamMemberIconPrimary.svg";

import "./MyAccountSideMenu.css";

const { Sider } = Layout;

const MaskIcon = ({ src }) => (
  <span
    className="SideNav__MaskIcon"
    style={{ "--icon-mask": `url(${src})` }}
    aria-hidden
  />
);

const MENU_ITEMS = [
  {
    key: "1",
    label: "My Profile",
    icon: <MaskIcon src={myProfileIconInactive} />,
    iconActive: <MaskIcon src={myProfileIconActive} />,
  },
  {
    key: "2",
    label: "Team Members",
    icon: <MaskIcon src={teamMemberIconInactive} />,
    iconActive: <MaskIcon src={teamMemberIconActive} />,
  },
  {
    key: "3",
    label: "Usage Metrics",
    icon: <MaskIcon src={usageMetricsIconInactive} />,
    iconActive: <MaskIcon src={usageMetricsIconActive} />,
    permission: permissions.subscriptions.viewUsageMetrics,
  },
  {
    key: "4",
    label: "Invoice",
    icon: <MaskIcon src={invoiceIconInactive} />,
    iconActive: <MaskIcon src={invoiceIconActive} />,
    permission: permissions.subscriptions.viewInvoice,
  },
  {
    key: "5",
    label: "Help?",
    icon: <MaskIcon src={helpIconInactive} />,
    iconActive: <MaskIcon src={helpIconActive} />,
  },
];

export default function MyAccountSideMenu({
  selectedMenuItem,
  handleMenuClick,
}) {
  const [collapsed, setCollapsed] = useState(getSideNavCollapsed);
  const billingAccess = {
    [permissions.subscriptions.viewUsageMetrics]: canViewUsageMetrics(),
    [permissions.subscriptions.viewInvoice]: canViewInvoice(),
  };
  const menuItems = MENU_ITEMS.filter(
    (item) => !item.permission || billingAccess[item.permission],
  );

  return (
    <Sider
      width={220}
      collapsedWidth={64}
      collapsed={collapsed}
      theme="light"
      trigger={null}
      className="MyAccountSideMenu"
    >
      <SideNav
        ariaLabel="My Account navigation"
        items={menuItems}
        activeKey={selectedMenuItem}
        collapsed={collapsed}
        onCollapsedChange={setCollapsed}
        onItemClick={(item) => {
          if (typeof handleMenuClick === "function") {
            handleMenuClick({ key: item.key });
          }
        }}
      />
    </Sider>
  );
}
